import { useQuery } from '@tanstack/react-query';
import { fetchProjectionReport } from '../services/projectionService';
import { PAGE_SIZE } from '../constants';
import { sprinklerProjectionKeys } from './queryKeys';
export function useProjectionData(filters, page, sortBy, sortDirection) {
    return useQuery({
        queryKey: sprinklerProjectionKeys.list(filters, page, sortBy, sortDirection),
        queryFn: () => fetchProjectionReport(filters, page, PAGE_SIZE, sortBy, sortDirection),
        staleTime: 10 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        keepPreviousData: true
    });
}
